import { render } from "./Contatos.vue?vue&type=template&id=b6160dd6&scoped=true"
import script from "./Contatos.vue?vue&type=script&lang=js"
export * from "./Contatos.vue?vue&type=script&lang=js"

import "./Contatos.vue?vue&type=style&index=0&id=b6160dd6&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6160dd6"]])

export default __exports__